<template>
    <div>
        <Loading :loading="isLoading"></Loading>
    </div>
</template>

<script>
import Loading from "@/components/Loading.vue";

export default {
    components: { Loading },

    data() {
        return {
            isLoading: false,
            code: null
        }
    },
    mounted() {
        this.isLoading = true;

        this.code = this.$route.query.code

        const path = `/`;
        let data = {
            code: this.code,
        };
        this.$store.dispatch("Auth/CheckUser", data)
            .then(() => {
                this.isLoading = false;

                this.$router.push(path);
            })
            .catch((error) => {
                // ดึง payload จาก error (รองรับหลายกรณี)
                const payload = error?.response?.data ?? error?.data ?? error ?? {};

                // รูป JSON ที่คุณเคยส่งมา: payload.result.result
                const result = payload?.result?.result ?? {}; 
                

                this.$store.commit('Auth/SET_REGISTER_DATA', result);
                this.$router.push({
                    path: "/register"
                });
            });
    }
}
</script>

<style scoped>
h1 {
    margin-bottom: 10px;
}
</style>